
/* eslint-disable */
    import {defineComponent, h, nextTick, reactive, watch, computed, ComputedRef, shallowRef, defineAsyncComponent} from 'vue'
    import {useRoute, useRouter} from "vue-router";
    import  reportMsgUt from "@/util/reportMsg";
    import {useStore} from '@/store';
    import baseModules from './baseModules.js';
    const renderList = [
        'navigation',
        'summary',
        ['loopCarVideo',
        'carInfo',
        'entrustDetect',
        'checkItem',
        'ecu',
        'remark',
        'detectMan',
        'serviceDesc',
        'reminder']
    ]

    let components = {};
    baseModules.forEach(item => {
        let comName = item;
        let modName = item.split('H5')[0];
        if(!components[comName]) {
            components[comName] = defineAsyncComponent(() => import(`./modules/${modName}/${comName}/index.vue`));
        }
    });
    // console.log('components:', components);
    interface State {
        reportMsg: object;
        componentList: any [];
    }
    export default defineComponent({
        name: "h5_index",
        components,
        setup() {
            let state: State = reactive({
                reportMsg: {},
                componentList: []
            })
            state.reportMsg = reportMsgUt;
            const {query} = useRoute();
            const router = useRouter();
            const {reportCode, templateCode, reportVersion, targetPage, lang} = query;
            if (lang === 'en') {
                document.title= "Vehicle Inspection Report";
            } else if (lang === 'ru') {
                document.title= "Отчет о проверке автомобиля";
            } else {
                document.title= "新能源汽车检测报告";
            }
            let store = useStore()
            store.dispatch('saveTocOnlyShowFlaw', false);
            
        // 通过接口返回的componentList判断各个模块是否展示（检测模块使用checkItem模块，且展示哪些检测模块在checkItem中判断）
        function findComponent(name){
            let cueMod = state.componentList.find(item => item.code === name || (name === 'checkItem' && item.styleCode.indexOf('checkItem')>=0));
            return cueMod;
        }
        // 通过接口返回的数据判断指定模块渲染哪个组件样式，并将对应的组件样式添加给模块
        function findComponentStyle(currentModule){
            let styleCode = currentModule.styleCode;
            let baseComponent = baseModules.find(item => item === styleCode);
            if (baseComponent) {
                currentModule.styleComponent = components[currentModule.styleCode];
            } else {
                let sCode = styleCode;
                sCode = sCode.split("_")[0];
                currentModule.styleComponent = components[sCode];
            }
            return currentModule;
        }
        // 设置每个模块展示的内容
        function setModule (moduleName: any) {
            let currentModule = findComponent(moduleName);
            if (currentModule) {
                let module = findComponentStyle(currentModule);
                return h(module.styleComponent, {renderData: module.configItems});
            } else {
                return null;
            }
        }
        let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
        watch(reportData, (data: any) => {
            console.log('watch=reportData:', data);
            const {componentList, ecuInfo} = JSON.parse(JSON.stringify(data));
            let checkItemList: any = [];
            let styleCode: string = '';
            let hasVideo = false;
            for (let i=0; i< componentList.length; i ++) {
                let item = componentList[i];
                if (item.type === 1 ) {
                    if (item.code === 'batterySafety' || item.code === 'batteryAppearance') {
                        componentList.splice(i, 1);
                        i--;
                        continue;
                    }
                    componentList.splice(i, 1);
                    checkItemList.push(item);
                    if (item.code === 'accident') {
                        styleCode = item.styleCode.split('_')[0];
                    }
                    i--;
                } else {
                    if (item.code === 'batteryDetect') {
                        componentList.splice(i, 1);
                        i--;
                        continue;
                    }
                    if (item.code === 'video') {
                        hasVideo = true;
                    }
                }

            }
            componentList.push({
                code: 'checkItem',
                styleCode: styleCode,
                name: '检测模块',
                configItems: checkItemList
            })

            componentList.push({
                code: 'navigation',
                styleCode: `navigationH5${lang ? lang : ''}`,
                name: '导航条',
            })
            state.componentList = componentList;
            console.log('componentList:', state.componentList);
        }, {immediate: true, deep: true})
        return {
            state,
            store,
            setModule
        }
        },
        render() {
            let renderContent: (any) = [];
            for (let i = 0; i < renderList.length; i += 1) {
                let item = renderList[i];
                if (typeof item === 'string') {
                    renderContent.push(this.setModule(item))
                } else if (typeof item === 'object') {
                    let childNodesList: (any) = [];
                    for (let j = 0; j < item.length; j += 1) {
                        let jtem: any = item[j];
                        childNodesList.push(this.setModule(jtem));
                    }
                    renderContent.push(h('div', {class: 'reportMainBoxBattery', id:'reportMainBox'}, childNodesList))
                }
            }
            return h('keep-alive',{include: ''}, [h('div', {class:'reportApp'}, renderContent)]);
        },
    });
